import { useAtomValue, useSetAtom } from 'jotai';
import { sellerRolesAtom } from '../atoms';

export const useSellerRoles = () => useAtomValue(sellerRolesAtom);

export const useSellerRolesUpdater = () => useSetAtom(sellerRolesAtom);
